import { email } from "../../../../functions/SubmitRepairRequest/validation.json";

export const isValidEmailAddress = (emailAddress) => {
  const validEmailRegex = new RegExp(email.pattern);
  return (
    emailAddress.length >= email.minLength &&
    emailAddress.length <= email.maxLength &&
    validEmailRegex.test(emailAddress)
  );
};
